import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  menuOption: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: '1.5rem 0',
    fontSize: theme.size.sm,

    '& label': {
      cursor: 'pointer',
      userSelect: 'none'
    }
  },

  avatar: {
    width: 24,
    height: 24,
    marginRight: '0.5rem',
    fontSize: theme.size.sm
  },

  selected: {
    color: theme.palette.primary.main
  },

  pushLeft: {
    marginLeft: '0.5rem'
  }
}))

export default useStyles
